export default {
  path: '/substrates',
  name: 'substrates',
  component: () => import('./_views/KernelSubstrates.vue'),
  meta: {
    title: 'Substrates',
    navigation: {
      position: 5,
      name: 'Substrates',
      icon: 'view_quilt',
      specialQueries: ['suffix'],
      to: {
        name: 'substrates',
        query: {
          suffix: '',
          pageNum: '1',
        },
      },
    },
  },
};
